module.exports = __webpack_public_path__ + "img/plus-black.237c737d.svg";